// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainFooter-module__font-s-10___Xuhkq {
  font-size: 10px !important;
}

.MainFooter-module__font-s-12___OHkAk {
  font-size: 12px !important;
}

.MainFooter-module__font-s-13___W6ghB {
  font-size: 13px !important;
}

.MainFooter-module__font-s-14___Naoro {
  font-size: 14px !important;
}

.MainFooter-module__font-s-15___HLiUb {
  font-size: 15px !important;
}

.MainFooter-module__font-s-16___Zgmum {
  font-size: 16px !important;
}

.MainFooter-module__font-s-18___PpFmp {
  font-size: 18px !important;
}

.MainFooter-module__font-s-20___pLUeo {
  font-size: 20px !important;
}

.MainFooter-module__font-s-22___sy3pi {
  font-size: 22px !important;
}

.MainFooter-module__font-s-28___mJGde {
  font-size: 28px !important;
}

.MainFooter-module__font-w-400___mZC0e {
  font-weight: 400 !important;
}

.MainFooter-module__font-w-500___BkXSk {
  font-weight: 500 !important;
}

.MainFooter-module__font-w-600___Nlyys {
  font-weight: 600 !important;
}

.MainFooter-module__font-w-700___qkjXF {
  font-weight: 700 !important;
}

.MainFooter-module__p-5___oi7gs {
  padding: 5px !important;
}

.MainFooter-module__p-12___tgOOS {
  padding: 12px !important;
}

.MainFooter-module__p-16___vkoAu {
  padding: 16px !important;
}

.MainFooter-module__p-30___qzO0c {
  padding: 30px !important;
}

.MainFooter-module__p-b-0___jf6QP {
  padding-bottom: 0 !important;
}

.MainFooter-module__p-b-5___WY9e4 {
  padding-bottom: 5px !important;
}

.MainFooter-module__p-b-10___a42t_ {
  padding-bottom: 10px !important;
}

.MainFooter-module__p-b-12___TDrmz {
  padding-bottom: 12px !important;
}

.MainFooter-module__p-b-16___MqJvR {
  padding-bottom: 16px !important;
}

.MainFooter-module__p-b-18___tqFrs {
  padding-bottom: 18px !important;
}

.MainFooter-module__p-b-20___oXmMM {
  padding-bottom: 20px !important;
}

.MainFooter-module__p-b-25___OrVdi {
  padding-bottom: 25px !important;
}

.MainFooter-module__p-b-30___xg_sx {
  padding-bottom: 30px !important;
}

.MainFooter-module__p-b-50___fXzDb {
  padding-bottom: 50px !important;
}

.MainFooter-module__p-t-0___WueVL {
  padding-top: 0 !important;
}

.MainFooter-module__p-t-12___F2_TN {
  padding-top: 12px !important;
}

.MainFooter-module__p-t-16___l51iX {
  padding-top: 16px !important;
}

.MainFooter-module__p-t-18___Zeoga {
  padding-top: 18px !important;
}

.MainFooter-module__p-t-20___tp9EK {
  padding-top: 20px !important;
}

.MainFooter-module__p-t-30___tCTYm {
  padding-top: 30px !important;
}

.MainFooter-module__p-t-40___nIY0z {
  padding-top: 40px !important;
}

.MainFooter-module__p-t-50___NrxPi {
  padding-top: 50px !important;
}

.MainFooter-module__p-l-20___Z_m5z {
  padding-left: 20px !important;
}

.MainFooter-module__p-l-30___XNvIU {
  padding-left: 30px !important;
}

.MainFooter-module__p-l-40___l9fHF {
  padding-left: 40px !important;
}

.MainFooter-module__p-r-16___jAeSC {
  padding-right: 16px !important;
}

.MainFooter-module__p-r-20___aLMFa {
  padding-right: 20px !important;
}

.MainFooter-module__p-r-30___toUt4 {
  padding-right: 30px !important;
}

.MainFooter-module__p-r-50___GWseX {
  padding-right: 50px !important;
}

.MainFooter-module__p-r-60___GpZqE {
  padding-right: 60px !important;
}

.MainFooter-module__m-b-1___Degqq {
  margin-bottom: 1px !important;
}

.MainFooter-module__m-b-2___GAy8y {
  margin-bottom: 2px !important;
}

.MainFooter-module__m-b-6___p_3PR {
  margin-bottom: 6px !important;
}

.MainFooter-module__m-b-8___N2f90 {
  margin-bottom: 8px !important;
}

.MainFooter-module__m-b-10___QjIZI {
  margin-bottom: 10px !important;
}

.MainFooter-module__m-b-14___by1uQ {
  margin-bottom: 14px !important;
}

.MainFooter-module__m-b-16___OiUmc {
  margin-bottom: 16px !important;
}

.MainFooter-module__m-b-20___RW5Hj {
  margin-bottom: 20px !important;
}

.MainFooter-module__m-b-22___m9uLs {
  margin-bottom: 22px !important;
}

.MainFooter-module__m-b-24___UeUAV {
  margin-bottom: 24px !important;
}

.MainFooter-module__m-b-30___QV853 {
  margin-bottom: 30px !important;
}

.MainFooter-module__m-b-32___iztfR {
  margin-bottom: 32px !important;
}

.MainFooter-module__m-b-40___J30NJ {
  margin-bottom: 40px !important;
}

.MainFooter-module__m-t-2___pgg7v {
  margin-top: 2px !important;
}

.MainFooter-module__m-t-3___tORA1 {
  margin-top: 3px !important;
}

.MainFooter-module__m-t-4___FsAaW {
  margin-top: 4px !important;
}

.MainFooter-module__m-t-5___seYN_ {
  margin-top: 5px !important;
}

.MainFooter-module__m-t-8___SHp4O {
  margin-top: 8px !important;
}

.MainFooter-module__m-t-10___ixbQE {
  margin-top: 10px !important;
}

.MainFooter-module__m-t-15___fJCQq {
  margin-top: 15px !important;
}

.MainFooter-module__m-t-16___ahoWf {
  margin-top: 16px !important;
}

.MainFooter-module__m-t-20___yPMhQ {
  margin-top: 20px !important;
}

.MainFooter-module__m-t-22___OUFeK {
  margin-top: 22px !important;
}

.MainFooter-module__m-t-30___pVMxe {
  margin-top: 30px !important;
}

.MainFooter-module__m-t-32___J8Cip {
  margin-top: 32px !important;
}

.MainFooter-module__m-l-auto___YjHwR {
  margin-left: auto !important;
}

.MainFooter-module__m-l-4___EaCA1 {
  margin-left: 4px !important;
}

.MainFooter-module__m-l-5___Q82ne {
  margin-left: 5px !important;
}

.MainFooter-module__m-l-6___eHaIt {
  margin-left: 6px !important;
}

.MainFooter-module__m-l-8___sKIog {
  margin-left: 8px !important;
}

.MainFooter-module__m-l-10___Auo08 {
  margin-left: 10px !important;
}

.MainFooter-module__m-l-16___eD852 {
  margin-left: 16px !important;
}

.MainFooter-module__m-l-20___xVv9F {
  margin-left: 20px !important;
}

.MainFooter-module__m-l-24___jhCWD {
  margin-left: 24px !important;
}

.MainFooter-module__m-l-30___wRk1N {
  margin-left: 30px !important;
}

.MainFooter-module__m-l-35___TWxG8 {
  margin-left: 35px !important;
}

.MainFooter-module__m-l-40___uKfIB {
  margin-left: 40px !important;
}

.MainFooter-module__m-r-8___YDILr {
  margin-right: 8px !important;
}

.MainFooter-module__m-r-10___CbkyR {
  margin-right: 10px !important;
}

.MainFooter-module__m-r-16___dQeOC {
  margin-right: 16px !important;
}

.MainFooter-module__m-r-20___gMXOt {
  margin-right: 20px !important;
}

.MainFooter-module__m-r-24___NpWHQ {
  margin-right: 24px !important;
}

.MainFooter-module__m-r-30___H52Rm {
  margin-right: 30px !important;
}

.MainFooter-module__m-r-40___sPeP7 {
  margin-right: 40px !important;
}

.MainFooter-module__border-r-3___bwwIn {
  border-radius: 3px !important;
}

.MainFooter-module__border-r-4____gPGF {
  border-radius: 4px !important;
}

.MainFooter-module__border-r-6___L6sb8 {
  border-radius: 6px !important;
}

.MainFooter-module__border-r-10___iGr2h {
  border-radius: 10px !important;
}

.MainFooter-module__border-r-12___Zptzw {
  border-radius: 12px !important;
}

.MainFooter-module__border-r-16___yICCm {
  border-radius: 16px !important;
}

.MainFooter-module__border-r-50___gxv2w {
  border-radius: 50% !important;
}

.MainFooter-module__primary-border___bQfRV {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MainFooter-module__primary-border-b___VJu_V {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MainFooter-module__primary-border-t___qhqsc {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MainFooter-module__primary-border-l___pGMXJ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MainFooter-module__primary-border-r___GUiom {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MainFooter-module__secondary-border___mf1YH {
  border: 1px solid #637768;
}

.MainFooter-module__secondary-border-b___Tsf8s {
  border-bottom: 1px solid #637768;
}

.MainFooter-module__secondary-border-t___Ww3KZ {
  border-top: 1px solid #637768;
}

.MainFooter-module__secondary-border-l___Hgfbl {
  border-left: 1px solid #637768;
}

.MainFooter-module__secondary-border-r___gZ4Ov {
  border-right: 1px solid #637768;
}

.MainFooter-module__gap-0___vreUN {
  gap: 0 !important;
}

.MainFooter-module__gap-2___vj8Le {
  gap: 2px !important;
}

.MainFooter-module__gap-4___VvPXL {
  gap: 4px !important;
}

.MainFooter-module__gap-5___Tt7Tk {
  gap: 5px !important;
}

.MainFooter-module__gap-6___d58W0 {
  gap: 6px !important;
}

.MainFooter-module__gap-8___nnUz1 {
  gap: 8px !important;
}

.MainFooter-module__gap-10___OmepY {
  gap: 10px !important;
}

.MainFooter-module__gap-12___EqF7U {
  gap: 12px !important;
}

.MainFooter-module__gap-14___x3uyQ {
  gap: 14px !important;
}

.MainFooter-module__gap-16___K6JEA {
  gap: 16px !important;
}

.MainFooter-module__gap-18___FPOOU {
  gap: 18px !important;
}

.MainFooter-module__gap-20___bVZBh {
  gap: 20px !important;
}

.MainFooter-module__gap-24___SyvYi {
  gap: 24px !important;
}

.MainFooter-module__gap-26___w_6ho {
  gap: 26px !important;
}

.MainFooter-module__gap-30___lkyxF {
  gap: 30px !important;
}

.MainFooter-module__gap-32___KcqD9 {
  gap: 32px !important;
}

.MainFooter-module__gap-40___AGnM_ {
  gap: 40px !important;
}

.MainFooter-module__gap-50___qWZSb {
  gap: 50px !important;
}

.MainFooter-module__flex-1___s3DLC {
  flex: 1;
}

.MainFooter-module__flex-none___krM4U {
  flex: none !important;
}

.MainFooter-module__flex-column___Q8AjX {
  display: flex;
  flex-direction: column !important;
}

.MainFooter-module__flex-row___L_6Ep {
  display: flex;
  flex-direction: row !important;
}

.MainFooter-module__vertically-centered___YQscP {
  display: flex;
  align-items: center !important;
}

.MainFooter-module__horizontally-centered___SdhIC {
  display: flex;
  justify-content: center !important;
}

.MainFooter-module__horizontally-end___FAOrM {
  display: flex;
  justify-content: end !important;
}

.MainFooter-module__vertically-start___uKnnJ {
  display: flex;
  align-items: start !important;
}

.MainFooter-module__space-between___jmPcW {
  display: flex;
  justify-content: space-between !important;
}

.MainFooter-module__flex-wrap___onCrG {
  flex-wrap: wrap !important;
}

.MainFooter-module__height-100___Hrh72 {
  height: 100%;
}

.MainFooter-module__width-50___YnPld {
  width: 50% !important;
}

.MainFooter-module__width-100___LvetB {
  width: 100%;
}

.MainFooter-module__cursor-pointer___JHI9Z {
  cursor: pointer;
}

.MainFooter-module__cursor-not-allowed___HYWx7 {
  cursor: not-allowed !important;
}

.MainFooter-module__absolute-centered___TzfVs {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MainFooter-module__absolute___pE36t {
  position: absolute;
}

.MainFooter-module__relative___oJe6e {
  position: relative;
}

.MainFooter-module__fixed___r9yJw {
  position: fixed;
}

.MainFooter-module__visible___N9JXh {
  opacity: 1;
}

.MainFooter-module__invisible___QhhCv {
  opacity: 0;
}

.MainFooter-module__col-90___fFGEC {
  width: 90% !important;
}

.MainFooter-module__col-auto___uBT6Q {
  width: auto !important;
}

.MainFooter-module__medical-tabs___eKrBN {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MainFooter-module__medical-table-new___ie4Oj {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MainFooter-module__medical-table-new___ie4Oj:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MainFooter-module__medical-table-new___ie4Oj::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MainFooter-module__medical-table-new___ie4Oj::-webkit-scrollbar-track {
  display: none;
}
.MainFooter-module__medical-table-new___ie4Oj.MainFooter-module__no-pagination___GRqU7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MainFooter-module__medical-table-new___ie4Oj.MainFooter-module__no-pagination___GRqU7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MainFooter-module__medical-table-new___ie4Oj.MainFooter-module__no-pagination___GRqU7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MainFooter-module__medical-table-new___ie4Oj.MainFooter-module__no-pagination___GRqU7::-webkit-scrollbar-track {
  display: none;
}

.MainFooter-module__medical-table-empty___mfjuN {
  padding: 14px 40px !important;
}

.MainFooter-module__icon-btn___De8F5 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MainFooter-module__search-icon___Wxq6R {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MainFooter-module__disable-select___dtrJi {
  user-select: none;
}

.MainFooter-module__break-word___vBvnC {
  word-break: break-word;
}

.MainFooter-module__popup-clear-btn___vIud7 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MainFooter-module__scroll-m-b-20___nSI1_ {
  scroll-margin-bottom: 20px;
}

.MainFooter-module__footer___iXKc_ {
  position: relative;
  height: var(--patient-details-footer);
  background-color: #fdfcfa;
  border-top: 1px solid #e6e7e8;
  box-sizing: border-box;
  padding: 0 30px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainFooter/MainFooter.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.footer {\n  position: relative;\n  height: var(--patient-details-footer);\n  background-color: get-color(grayNew, ultra-light);\n  border-top: 1px solid get-color(gray, light);\n  box-sizing: border-box;\n  padding: 0 30px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MainFooter-module__font-s-10___Xuhkq`,
	"fontS12": `MainFooter-module__font-s-12___OHkAk`,
	"fontS13": `MainFooter-module__font-s-13___W6ghB`,
	"fontS14": `MainFooter-module__font-s-14___Naoro`,
	"fontS15": `MainFooter-module__font-s-15___HLiUb`,
	"fontS16": `MainFooter-module__font-s-16___Zgmum`,
	"fontS18": `MainFooter-module__font-s-18___PpFmp`,
	"fontS20": `MainFooter-module__font-s-20___pLUeo`,
	"fontS22": `MainFooter-module__font-s-22___sy3pi`,
	"fontS28": `MainFooter-module__font-s-28___mJGde`,
	"fontW400": `MainFooter-module__font-w-400___mZC0e`,
	"fontW500": `MainFooter-module__font-w-500___BkXSk`,
	"fontW600": `MainFooter-module__font-w-600___Nlyys`,
	"fontW700": `MainFooter-module__font-w-700___qkjXF`,
	"p5": `MainFooter-module__p-5___oi7gs`,
	"p12": `MainFooter-module__p-12___tgOOS`,
	"p16": `MainFooter-module__p-16___vkoAu`,
	"p30": `MainFooter-module__p-30___qzO0c`,
	"pB0": `MainFooter-module__p-b-0___jf6QP`,
	"pB5": `MainFooter-module__p-b-5___WY9e4`,
	"pB10": `MainFooter-module__p-b-10___a42t_`,
	"pB12": `MainFooter-module__p-b-12___TDrmz`,
	"pB16": `MainFooter-module__p-b-16___MqJvR`,
	"pB18": `MainFooter-module__p-b-18___tqFrs`,
	"pB20": `MainFooter-module__p-b-20___oXmMM`,
	"pB25": `MainFooter-module__p-b-25___OrVdi`,
	"pB30": `MainFooter-module__p-b-30___xg_sx`,
	"pB50": `MainFooter-module__p-b-50___fXzDb`,
	"pT0": `MainFooter-module__p-t-0___WueVL`,
	"pT12": `MainFooter-module__p-t-12___F2_TN`,
	"pT16": `MainFooter-module__p-t-16___l51iX`,
	"pT18": `MainFooter-module__p-t-18___Zeoga`,
	"pT20": `MainFooter-module__p-t-20___tp9EK`,
	"pT30": `MainFooter-module__p-t-30___tCTYm`,
	"pT40": `MainFooter-module__p-t-40___nIY0z`,
	"pT50": `MainFooter-module__p-t-50___NrxPi`,
	"pL20": `MainFooter-module__p-l-20___Z_m5z`,
	"pL30": `MainFooter-module__p-l-30___XNvIU`,
	"pL40": `MainFooter-module__p-l-40___l9fHF`,
	"pR16": `MainFooter-module__p-r-16___jAeSC`,
	"pR20": `MainFooter-module__p-r-20___aLMFa`,
	"pR30": `MainFooter-module__p-r-30___toUt4`,
	"pR50": `MainFooter-module__p-r-50___GWseX`,
	"pR60": `MainFooter-module__p-r-60___GpZqE`,
	"mB1": `MainFooter-module__m-b-1___Degqq`,
	"mB2": `MainFooter-module__m-b-2___GAy8y`,
	"mB6": `MainFooter-module__m-b-6___p_3PR`,
	"mB8": `MainFooter-module__m-b-8___N2f90`,
	"mB10": `MainFooter-module__m-b-10___QjIZI`,
	"mB14": `MainFooter-module__m-b-14___by1uQ`,
	"mB16": `MainFooter-module__m-b-16___OiUmc`,
	"mB20": `MainFooter-module__m-b-20___RW5Hj`,
	"mB22": `MainFooter-module__m-b-22___m9uLs`,
	"mB24": `MainFooter-module__m-b-24___UeUAV`,
	"mB30": `MainFooter-module__m-b-30___QV853`,
	"mB32": `MainFooter-module__m-b-32___iztfR`,
	"mB40": `MainFooter-module__m-b-40___J30NJ`,
	"mT2": `MainFooter-module__m-t-2___pgg7v`,
	"mT3": `MainFooter-module__m-t-3___tORA1`,
	"mT4": `MainFooter-module__m-t-4___FsAaW`,
	"mT5": `MainFooter-module__m-t-5___seYN_`,
	"mT8": `MainFooter-module__m-t-8___SHp4O`,
	"mT10": `MainFooter-module__m-t-10___ixbQE`,
	"mT15": `MainFooter-module__m-t-15___fJCQq`,
	"mT16": `MainFooter-module__m-t-16___ahoWf`,
	"mT20": `MainFooter-module__m-t-20___yPMhQ`,
	"mT22": `MainFooter-module__m-t-22___OUFeK`,
	"mT30": `MainFooter-module__m-t-30___pVMxe`,
	"mT32": `MainFooter-module__m-t-32___J8Cip`,
	"mLAuto": `MainFooter-module__m-l-auto___YjHwR`,
	"mL4": `MainFooter-module__m-l-4___EaCA1`,
	"mL5": `MainFooter-module__m-l-5___Q82ne`,
	"mL6": `MainFooter-module__m-l-6___eHaIt`,
	"mL8": `MainFooter-module__m-l-8___sKIog`,
	"mL10": `MainFooter-module__m-l-10___Auo08`,
	"mL16": `MainFooter-module__m-l-16___eD852`,
	"mL20": `MainFooter-module__m-l-20___xVv9F`,
	"mL24": `MainFooter-module__m-l-24___jhCWD`,
	"mL30": `MainFooter-module__m-l-30___wRk1N`,
	"mL35": `MainFooter-module__m-l-35___TWxG8`,
	"mL40": `MainFooter-module__m-l-40___uKfIB`,
	"mR8": `MainFooter-module__m-r-8___YDILr`,
	"mR10": `MainFooter-module__m-r-10___CbkyR`,
	"mR16": `MainFooter-module__m-r-16___dQeOC`,
	"mR20": `MainFooter-module__m-r-20___gMXOt`,
	"mR24": `MainFooter-module__m-r-24___NpWHQ`,
	"mR30": `MainFooter-module__m-r-30___H52Rm`,
	"mR40": `MainFooter-module__m-r-40___sPeP7`,
	"borderR3": `MainFooter-module__border-r-3___bwwIn`,
	"borderR4": `MainFooter-module__border-r-4____gPGF`,
	"borderR6": `MainFooter-module__border-r-6___L6sb8`,
	"borderR10": `MainFooter-module__border-r-10___iGr2h`,
	"borderR12": `MainFooter-module__border-r-12___Zptzw`,
	"borderR16": `MainFooter-module__border-r-16___yICCm`,
	"borderR50": `MainFooter-module__border-r-50___gxv2w`,
	"primaryBorder": `MainFooter-module__primary-border___bQfRV`,
	"primaryBorderB": `MainFooter-module__primary-border-b___VJu_V`,
	"primaryBorderT": `MainFooter-module__primary-border-t___qhqsc`,
	"primaryBorderL": `MainFooter-module__primary-border-l___pGMXJ`,
	"primaryBorderR": `MainFooter-module__primary-border-r___GUiom`,
	"secondaryBorder": `MainFooter-module__secondary-border___mf1YH`,
	"secondaryBorderB": `MainFooter-module__secondary-border-b___Tsf8s`,
	"secondaryBorderT": `MainFooter-module__secondary-border-t___Ww3KZ`,
	"secondaryBorderL": `MainFooter-module__secondary-border-l___Hgfbl`,
	"secondaryBorderR": `MainFooter-module__secondary-border-r___gZ4Ov`,
	"gap0": `MainFooter-module__gap-0___vreUN`,
	"gap2": `MainFooter-module__gap-2___vj8Le`,
	"gap4": `MainFooter-module__gap-4___VvPXL`,
	"gap5": `MainFooter-module__gap-5___Tt7Tk`,
	"gap6": `MainFooter-module__gap-6___d58W0`,
	"gap8": `MainFooter-module__gap-8___nnUz1`,
	"gap10": `MainFooter-module__gap-10___OmepY`,
	"gap12": `MainFooter-module__gap-12___EqF7U`,
	"gap14": `MainFooter-module__gap-14___x3uyQ`,
	"gap16": `MainFooter-module__gap-16___K6JEA`,
	"gap18": `MainFooter-module__gap-18___FPOOU`,
	"gap20": `MainFooter-module__gap-20___bVZBh`,
	"gap24": `MainFooter-module__gap-24___SyvYi`,
	"gap26": `MainFooter-module__gap-26___w_6ho`,
	"gap30": `MainFooter-module__gap-30___lkyxF`,
	"gap32": `MainFooter-module__gap-32___KcqD9`,
	"gap40": `MainFooter-module__gap-40___AGnM_`,
	"gap50": `MainFooter-module__gap-50___qWZSb`,
	"flex1": `MainFooter-module__flex-1___s3DLC`,
	"flexNone": `MainFooter-module__flex-none___krM4U`,
	"flexColumn": `MainFooter-module__flex-column___Q8AjX`,
	"flexRow": `MainFooter-module__flex-row___L_6Ep`,
	"verticallyCentered": `MainFooter-module__vertically-centered___YQscP`,
	"horizontallyCentered": `MainFooter-module__horizontally-centered___SdhIC`,
	"horizontallyEnd": `MainFooter-module__horizontally-end___FAOrM`,
	"verticallyStart": `MainFooter-module__vertically-start___uKnnJ`,
	"spaceBetween": `MainFooter-module__space-between___jmPcW`,
	"flexWrap": `MainFooter-module__flex-wrap___onCrG`,
	"height100": `MainFooter-module__height-100___Hrh72`,
	"width50": `MainFooter-module__width-50___YnPld`,
	"width100": `MainFooter-module__width-100___LvetB`,
	"cursorPointer": `MainFooter-module__cursor-pointer___JHI9Z`,
	"cursorNotAllowed": `MainFooter-module__cursor-not-allowed___HYWx7`,
	"absoluteCentered": `MainFooter-module__absolute-centered___TzfVs`,
	"absolute": `MainFooter-module__absolute___pE36t`,
	"relative": `MainFooter-module__relative___oJe6e`,
	"fixed": `MainFooter-module__fixed___r9yJw`,
	"visible": `MainFooter-module__visible___N9JXh`,
	"invisible": `MainFooter-module__invisible___QhhCv`,
	"col90": `MainFooter-module__col-90___fFGEC`,
	"colAuto": `MainFooter-module__col-auto___uBT6Q`,
	"medicalTabs": `MainFooter-module__medical-tabs___eKrBN`,
	"medicalTableNew": `MainFooter-module__medical-table-new___ie4Oj`,
	"noPagination": `MainFooter-module__no-pagination___GRqU7`,
	"medicalTableEmpty": `MainFooter-module__medical-table-empty___mfjuN`,
	"iconBtn": `MainFooter-module__icon-btn___De8F5`,
	"searchIcon": `MainFooter-module__search-icon___Wxq6R`,
	"disableSelect": `MainFooter-module__disable-select___dtrJi`,
	"breakWord": `MainFooter-module__break-word___vBvnC`,
	"popupClearBtn": `MainFooter-module__popup-clear-btn___vIud7`,
	"scrollMB20": `MainFooter-module__scroll-m-b-20___nSI1_`,
	"footer": `MainFooter-module__footer___iXKc_`
};
module.exports = ___CSS_LOADER_EXPORT___;
